import '@splidejs/splide/dist/js/splide.min.js'
import debounce from 'lodash.debounce'

function checkArrows(splide, arrows) {
    // hide arrows if not needed
    const items = splide.length
    const perPage = splide.options.perPage
    if (items <= perPage) {
        arrows.style.display = 'none'
        splide.options = {
            drag: false
        }
    }
    else {
        arrows.style.display = 'block'
        splide.options = {
            drag: true
        }
    }
}

export default function(sliderClass) {
    const sliders = document.querySelectorAll(sliderClass)
    sliders.forEach(item => {
        const arrows = item.querySelector('.splide__arrows')
        const splide = new Splide(item)
        splide.mount()
        if(arrows) {
            checkArrows(splide, arrows)
            window.addEventListener('resize', debounce(() => { checkArrows(splide, arrows)}, 100))
        }
    })
}